import { CoreEvents, DEFAULT_PLAYER_STATE, } from "@tv4/avod-web-player-common";
import { useEffect, useState } from "react";
const useCore = (core) => {
    const [playerState, setPlayerState] = useState(DEFAULT_PLAYER_STATE);
    const [adMarkers, setAdMarkers] = useState([]);
    const [currentAdBreak, setCurrentAdBreak] = useState();
    const [currentAd, setCurrentAd] = useState();
    const [controls, setControls] = useState(null);
    const [error, setError] = useState(null);
    const [options, setOptions] = useState(core.getOptions());
    const [chromeCastManager, setChromeCastManager] = useState(core.getChromeCastManager());
    function resetAdState(resetMarkers = true) {
        if (resetMarkers) {
            setAdMarkers([]);
        }
        setCurrentAdBreak(undefined);
        setCurrentAd(undefined);
    }
    useEffect(() => {
        core.on(CoreEvents.STATE_CHANGED, ({ state }) => {
            setPlayerState(state);
        });
        core.on(CoreEvents.RESET, (payload) => resetAdState(!payload.modeSwitch));
        core.on(CoreEvents.CHROMECAST_CONTENT_UPDATED, () => resetAdState());
        core.on(CoreEvents.LOADED_PLAYBACK, () => {
            // Error needs to be reset on loaded instead of reset because we reset the player after an error
            setError(null);
            setControls(core.getControls());
        });
        core.on(CoreEvents.ERROR, ({ error: e }) => {
            setError(e);
        });
        core.on(CoreEvents.LOAD_PLAYBACK_ERROR, ({ error: e }) => {
            setError(e);
        });
        core.on(CoreEvents.CORE_OPTIONS_CHANGED, () => {
            setOptions(core.getOptions());
        });
        core.on(CoreEvents.AD_START, ({ ad }) => {
            setCurrentAd(ad);
        });
        core.on(CoreEvents.AD_RESUME, ({ ad }) => {
            setCurrentAd(ad);
        });
        core.on(CoreEvents.AD_MARKERS_UPDATED, (payload) => {
            setAdMarkers(payload.adMarkers);
        });
        core.on(CoreEvents.BREAK_START, ({ adBreak }) => {
            setCurrentAdBreak(adBreak);
        });
        core.on(CoreEvents.BREAK_END, () => {
            setCurrentAdBreak(undefined);
            setCurrentAd(undefined);
        });
        core.on(CoreEvents.CHROMECAST_AD_START, ({ ad }) => {
            setCurrentAd(ad);
        });
        core.on(CoreEvents.CHROMECAST_SENDER_LOADED, () => {
            setChromeCastManager(core.getChromeCastManager());
        });
    }, [core]);
    useEffect(() => {
        if (!chromeCastManager)
            return;
        chromeCastManager.on(CoreEvents.CHROMECAST_CONNECTION_STATUS, ({ isConnected }) => {
            setControls(isConnected ? chromeCastManager.getControls() : core.getControls());
        });
    }, [chromeCastManager, core]);
    return {
        controls,
        playerState,
        adMarkers,
        currentAdBreak,
        currentAd,
        chromeCastManager,
        options,
        error,
    };
};
export default useCore;
